export interface Article {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  summary: string;
  content: string;
  tags: string[];
  views: string;
  publishDate: string;
  readTime: string;
  relatedArticles: string[];
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2024年最受欢迎的双男主韩漫推荐TOP10',
    author: '漫评人小林',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20recommendation%20list%20banner%2C%20various%20manhwa%20characters%20collage%20style%2C%20warm%20vibrant%20colors%2C%20clean%20editorial%20design%2C%20professional%20layout&width=1200&height=630&seq=article-01&orientation=landscape',
    category: 'shuang-nanzhu',
    summary: '盘点2024年度最受读者欢迎的双男主韩漫作品，从剧情、画风、口碑多维度分析，为漫迷们带来最权威的推荐榜单。',
    content: `<h2>2024双男主韩漫热潮</h2>
<p>2024年，韩国漫画产业持续蓬勃发展，双男主题材的作品尤其受到读者的青睐。这类作品以细腻的情感刻画、精彩的剧情设计和精美的画风著称，在全球范围内收获了大量粉丝。</p>
<h3>TOP 1：暗夜君主</h3>
<p>毫无疑问，<strong>《暗夜君主》</strong>是2024年最火爆的双男主韩漫。金贤秀老师以其独特的叙事风格和精湛的画技，塑造了两个性格鲜明又互为补充的男主角形象。故事中黑暗势力与光明希望的对抗，让读者欲罢不能。截至目前，《暗夜君主》已连载156话，累计阅读量突破128万。</p>
<h3>TOP 2：永恒之心</h3>
<p>郑雨盛老师的<strong>《永恒之心》</strong>以跨越千年的爱情故事俘获了无数读者的心。永生与转世的设定充满哲学思考，而两位主角之间的深情更是让人感动落泪。</p>
<h3>TOP 3：星光下的约定</h3>
<p>李敏雅老师的<strong>《星光下的约定》</strong>将娱乐圈题材与双男主恋爱完美结合。偶像与普通人的身份反差带来了丰富的戏剧冲突，加上细腻的情感发展，让这部作品成为年度热门。</p>
<h3>为什么双男主韩漫如此受欢迎？</h3>
<p>双男主韩漫之所以能够持续走红，关键在于以下几点：</p>
<ul><li>人物塑造立体丰满，两位主角各有特色又互补</li><li>情感发展细腻真实，节奏把控恰到好处</li><li>画风精美，场景和人物的表现力强</li><li>故事题材多样，涵盖奇幻、都市、校园等多个领域</li></ul>`,
    tags: ['双男主', '推荐', '排行榜', '韩漫'],
    views: '35.8万',
    publishDate: '2026-08-01',
    readTime: '8分钟',
    relatedArticles: ['article-2', 'article-5'],
  },
  {
    id: 'article-2',
    title: '韩漫免费阅读指南：这些平台你绝对不能错过',
    author: '漫迷小助手',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20platform%20screenshot%20mockup%2C%20digital%20comic%20reader%20interface%2C%20clean%20modern%20design%2C%20warm%20lighting%2C%20editorial%20style&width=1200&height=630&seq=article-02&orientation=landscape',
    category: 'mianfei-wuzhe',
    summary: '为你整理最全面的韩漫免费阅读资源，包含各大平台的使用攻略和独家推荐，让韩漫迷们轻松找到心仪的作品。',
    content: `<h2>如何找到高质量的韩漫免费阅读资源？</h2>
<p>随着韩漫在全球范围内的流行，越来越多的读者希望找到可靠的免费阅读渠道。本文将为大家详细介绍如何高效地获取优质韩漫资源，让你不再为找漫画而烦恼。</p>
<h3>韩漫免费阅读的优势</h3>
<p>相比实体漫画，在线免费阅读韩漫具有以下优势：</p>
<ul><li>随时随地阅读，不受时间和地点限制</li><li>更新速度快，第一时间获取最新章节</li><li>分类清晰，方便查找感兴趣的作品</li><li>社区互动，可以与其他漫迷交流讨论</li></ul>
<h3>热门韩漫分类推荐</h3>
<p>韩漫题材丰富多样，无论你喜欢什么类型的作品，都能找到合适的选择：</p>
<ul><li><strong>下拉双男主</strong>：以两位男性主角为核心的故事，情感细腻且剧情张力十足</li><li><strong>免费无遮</strong>：提供完整阅读体验的韩漫作品，画面精美无遮挡</li><li><strong>爱情恋爱</strong>：甜蜜浪漫的爱情故事，从校园到职场应有尽有</li><li><strong>玄幻科幻</strong>：天马行空的想象力和宏大的世界观构建</li></ul>
<h3>阅读韩漫的小技巧</h3>
<p>想要获得更好的阅读体验，可以参考以下建议：</p>
<ol><li>使用大屏幕设备阅读，可以获得更好的视觉效果</li><li>关注作者的更新动态，第一时间追更</li><li>参与社区讨论，结识志同道合的朋友</li><li>收藏喜欢的作品，方便下次继续阅读</li></ol>`,
    tags: ['免费阅读', '平台推荐', '韩漫指南'],
    views: '28.3万',
    publishDate: '2026-07-28',
    readTime: '6分钟',
    relatedArticles: ['article-1', 'article-6'],
  },
  {
    id: 'article-3',
    title: '从入门到精通：韩漫分类全解析',
    author: '资深漫编',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20category%20infographic%20style%2C%20colorful%20genre%20icons%20and%20labels%2C%20clean%20modern%20design%2C%20editorial%20layout%2C%20warm%20professional%20tone&width=1200&height=630&seq=article-03&orientation=landscape',
    category: 'mianfei-wuzhe',
    summary: '韩漫世界丰富多彩，从双男主到治愈系，从玄幻到都市。本文为你详细解读韩漫的各大分类，帮助你快速找到心仪的作品类型。',
    content: `<h2>韩漫分类全解析</h2>
<p>韩漫的分类体系丰富多元，对于新入坑的漫迷来说可能会有些眼花缭乱。本文将从多个维度为你详细解读韩漫的各大分类，帮助你快速定位自己喜欢的作品类型。</p>
<h3>按下拉方式分类</h3>
<p><strong>下拉双男主</strong>是韩漫中最具代表性的阅读形式之一。这类作品采用垂直滚动的阅读方式，两位男性主角的故事线相互交织，既方便在手机上阅读，又能展现出独特的叙事节奏。</p>
<h3>按题材内容分类</h3>
<ul><li><strong>爱情恋爱类</strong>：以情感发展为主线，涵盖纯爱、虐恋、治愈等多种风格</li><li><strong>玄幻科幻类</strong>：架空世界观，融合魔法、超能力、未来科技等元素</li><li><strong>现实都市类</strong>：以现代都市为背景，讲述职场、生活中的故事</li><li><strong>悬疑推理类</strong>：充满悬念和反转，让人欲罢不能的解谜之旅</li><li><strong>校园青春类</strong>：以校园生活为舞台，展现青春的美好与烦恼</li><li><strong>古装武侠类</strong>：古代背景下的侠义江湖与爱恨情仇</li></ul>
<h3>如何选择适合自己的韩漫？</h3>
<p>如果你是初次接触韩漫，建议从以下几个方向入手：</p>
<ol><li>先确定自己偏好的题材类型</li><li>查看热榜和推荐，了解当前流行作品</li><li>阅读前几话判断画风和叙事是否合拍</li><li>关注完结作品，可以一口气读完获得完整体验</li></ol>`,
    tags: ['分类指南', '韩漫入门', '题材解析'],
    views: '18.7万',
    publishDate: '2026-07-25',
    readTime: '10分钟',
    relatedArticles: ['article-1', 'article-4'],
  },
  {
    id: 'article-4',
    title: '好看的漫画推荐：这些隐藏的宝藏韩漫你不能错过',
    author: '漫画猎人',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20hidden%20gems%20collection%2C%20beautiful%20manhwa%20covers%20arranged%20artistically%2C%20warm%20golden%20lighting%2C%20clean%20editorial%20design%2C%20discovery%20theme&width=1200&height=630&seq=article-04&orientation=landscape',
    category: 'mianfei-wuzhe',
    summary: '除了热门作品之外，还有很多被低估的优质韩漫。本文为你挖掘那些隐藏在角落里的宝藏漫画，每一部都值得细细品味。',
    content: `<h2>挖掘韩漫中的隐藏宝藏</h2>
<p>在韩漫的世界里，总有一些作品因为宣传不足或者题材小众而没有被大众发现。但正是这些作品，往往蕴含着最真挚的情感和最独特的故事。</p>
<h3>治愈系宝藏：《花间秘语》</h3>
<p><strong>《花间秘语》</strong>以一家神秘花店为舞台，每一话都是一个独立而温暖的小故事。李瑞妍老师用柔和的笔触和细腻的文字，为读者打造了一个充满花香和温情的精神角落。虽然是单元剧形式，但主角的成长线索贯穿始终，读完让人心里暖暖的。</p>
<h3>悬疑黑马：《影子猎人》</h3>
<p>朴俊昊老师的<strong>《影子猎人》</strong>将都市奇幻与硬核动作完美融合。紧凑的剧情节奏、精心设计的战斗场面，加上深层的社会隐喻，让这部作品在悬疑类韩漫中独树一帜。</p>
<h3>韩漫免费无遮作品推荐</h3>
<p>以下作品都是<strong>韩漫免费无遮</strong>阅读的优质选择：</p>
<ul><li>《那年夏天的风》—— 青春校园题材，画风清新自然</li><li>《甜蜜办公室》—— 都市职场恋爱，轻松幽默又温馨</li><li>《剑与花的誓约》—— 古装武侠，已完结可一口气读完</li></ul>`,
    tags: ['推荐', '宝藏漫画', '冷门佳作', '韩漫'],
    views: '22.1万',
    publishDate: '2026-07-22',
    readTime: '7分钟',
    relatedArticles: ['article-3', 'article-6'],
  },
  {
    id: 'article-5',
    title: '双男主韩漫的魅力：深度解析这一独特题材',
    author: '漫评人小林',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dual%20male%20lead%20analysis%2C%20artistic%20character%20composition%2C%20emotional%20connection%20visual%2C%20clean%20editorial%20design%2C%20professional%20art%20style&width=1200&height=630&seq=article-05&orientation=landscape',
    category: 'shuang-nanzhu',
    summary: '为什么双男主题材在韩漫中如此受欢迎？本文从叙事结构、角色塑造和文化背景等方面，深度解析双男主韩漫的独特魅力。',
    content: `<h2>双男主韩漫的独特魅力</h2>
<p><strong>双男主</strong>题材是韩漫中最具辨识度的类型之一。不同于传统的单一主角结构，双男主作品通过两位男主角的互动和成长，展现出更加丰富和多元的叙事层次。</p>
<h3>双男主设定的叙事优势</h3>
<p>双男主设定为创作者提供了以下几个方面的叙事优势：</p>
<ul><li><strong>视角多元化</strong>：两个主角可以呈现事件的不同侧面，让故事更加立体</li><li><strong>情感张力</strong>：主角间的互动和关系发展本身就是强大的情节驱动力</li><li><strong>角色互补</strong>：性格各异的两位主角可以互相补充，满足不同读者的喜好</li></ul>
<h3>经典双男主韩漫推荐</h3>
<p>以下是一些不容错过的<strong>下拉双男主</strong>韩漫经典：</p>
<ul><li>《暗夜君主》—— 热血与智谋的完美搭配</li><li>《永恒之心》—— 跨越千年的深情守候</li><li>《星光下的约定》—— 娱乐圈中的真挚情感</li><li>《总裁的契约恋人》—— 契约之下的真心流露</li></ul>
<h3>双男主题材的未来趋势</h3>
<p>随着读者审美的不断提升，双男主题材也在不断创新。从传统的对抗到合作，从简单的二元对立到复杂的关系网络，这一题材正在展现出越来越丰富的可能性。</p>`,
    tags: ['双男主', '题材分析', '韩漫文化'],
    views: '31.5万',
    publishDate: '2026-07-20',
    readTime: '9分钟',
    relatedArticles: ['article-1', 'article-3'],
  },
  {
    id: 'article-6',
    title: '韩漫免费无遮阅读：完整畅享每一话的精彩',
    author: '漫迷小助手',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20full%20page%20reading%20experience%2C%20clean%20unobstructed%20comic%20layout%2C%20digital%20reader%20mockup%2C%20warm%20inviting%20design%2C%20editorial%20style&width=1200&height=630&seq=article-06&orientation=landscape',
    category: 'mianfei-wuzhe',
    summary: '韩漫免费无遮阅读让读者能够完整享受每一话的精彩内容。本文带你了解无遮阅读的体验优势，并推荐优质的无遮韩漫资源。',
    content: `<h2>畅享韩漫免费无遮阅读体验</h2>
<p>对于漫迷来说，<strong>韩漫免费无遮</strong>阅读是最理想的阅读方式。无遮挡的完整画面、流畅的阅读体验，让每一部韩漫都能以最佳状态呈现给读者。</p>
<h3>什么是韩漫免费无遮？</h3>
<p>韩漫免费无遮指的是读者可以免费阅读完整的漫画内容，画面不受任何遮挡或删减。这意味着：</p>
<ul><li>每一页的原画都能完整呈现</li><li>画面的细节和美感得到充分展现</li><li>阅读体验流畅自然，没有中断感</li><li>可以完全沉浸在故事的世界中</li></ul>
<h3>无遮阅读平台的选择标准</h3>
<p>选择优质的韩漫免费无遮阅读平台，可以从以下几个方面考量：</p>
<ol><li>更新速度：是否能第一时间同步最新章节</li><li>画质表现：图片是否高清，色彩是否准确</li><li>分类体系：是否便于查找感兴趣的作品</li><li>阅读体验：加载速度快慢，界面是否友好</li><li>作品丰富度：收录的漫画数量和质量</li></ol>
<h3>热门韩漫免费无遮作品</h3>
<p>目前最受欢迎的<strong>韩漫免费无遮漫画</strong>包括：</p>
<ul><li>《血月传说》 —— 悬疑奇幻，画风震撼</li><li>《破晓之战》 —— 末世科幻，场面宏大</li><li>《无限深渊》 —— 玄幻冒险，世界观独特</li></ul>`,
    tags: ['免费无遮', '阅读体验', '平台推荐', '韩漫'],
    views: '26.9万',
    publishDate: '2026-07-18',
    readTime: '5分钟',
    relatedArticles: ['article-2', 'article-4'],
  },
];

export const getArticleById = (id: string) => articles.find(a => a.id === id);

export const getArticlesByCategory = (categorySlug: string) =>
  articles.filter(a => a.category === categorySlug);

export const getRecentArticles = (limit: number = 6) =>
  [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);